import {gql} from "@apollo/client";
import {client} from "graphql/client";

export const GET_ACCOUNT_DELIVERY_DRIVER_BY_ACCOUNT_ID = gql`
    query GetAccountDeliveryDriverByAccountId($accountId: Long!) {
        getAccountDeliveryDriverByAccountId(accountId: $accountId) {
            id
            accountId
            dspId
            driverLicenseNumber
            vehicleTypeId
            vehiclePlate
            vehicleImageS3KeysJson
            vehicleImageUrls
            isOnDuty
        }
    }
`;

export interface AccountDeliveryDriverType {
    id: number;
    accountId: number;
    dspId: number;
    driverLicenseNumber: string;
    vehicleTypeId: number;
    vehiclePlate: string;
    vehicleImageS3KeysJson: string[];
    vehicleImageUrls: string[];
    isOnDuty: boolean;
}

export interface GetAccountDeliveryDriverByAccountIdQueryVariables {
    accountId: number;
}

export interface GetAccountDeliveryDriverByAccountIdQuery {
    getAccountDeliveryDriverByAccountId: AccountDeliveryDriverType;
}

export const getAccountDeliveryDriverByAccountId = async (accountId: number): Promise<AccountDeliveryDriverType> => {
    const {data} = await client.query<GetAccountDeliveryDriverByAccountIdQuery, GetAccountDeliveryDriverByAccountIdQueryVariables>({
        query: GET_ACCOUNT_DELIVERY_DRIVER_BY_ACCOUNT_ID,
        variables: {accountId}
    });
    return data.getAccountDeliveryDriverByAccountId;
}